import React from "react";
import {viewSettings} from "../builder/HexCube";


export default function AdjustCube(
    {width, setWidth, step, setStep, view, setView}:
    {width:number, setWidth:(width:number)=>void, step:number, setStep:(step:number)=>void, view:viewSettings, setView:(view:viewSettings)=>void}
){

    let handleWidthChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setWidth(+(e.target.value))
        if((+(e.target.value))*step>256){
            setStep(256/(+(e.target.value)))
        }
    }

    let handleStepChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setStep(+(e.target.value))
        if((+(e.target.value))*width>256){
            setWidth(256/(+(e.target.value)))
        }
    }

    let handleViewChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setView(e.target.value as viewSettings)
    }

    // note: the tags and numbers are aligned with the size of step, the label text is how many items will appear in the row
    return (<div>
        Grid Settings<br/>

        <span>Grid Width:</span>
        <input type="radio" name="width" onChange={handleWidthChange} id="boxw8" value="8" checked={width===8} />
        <label htmlFor='boxw8'>8</label>
        &nbsp;
        <input type="radio" name="width" onChange={handleWidthChange} id="boxw16" value="16" checked={width===16} />
        <label htmlFor='boxw16'>16</label>
        &nbsp;
        <input type="radio" name="width" onChange={handleWidthChange} id="boxw32" value="32" checked={width===32} />
        <label htmlFor='boxw32'>32</label>

        <br/>

        <span>Color Interval:</span>
        <input type="radio" name="step" onChange={handleStepChange} id="boxs2" value="2" checked={step===2} />
        <label htmlFor='boxs2'>2</label>
        &nbsp;
        <input type="radio" name="step" onChange={handleStepChange} id="boxs4" value="4" checked={step===4} />
        <label htmlFor='boxs4'>4</label>
        &nbsp;
        <input type="radio" name="step" onChange={handleStepChange} id="boxs8" value="8" checked={step===8} />
        <label htmlFor='boxs8'>8</label>
        &nbsp;
        <input type="radio" name="step" onChange={handleStepChange} id="boxs16" value="16" checked={step===16} />
        <label htmlFor='boxs16'>16</label>
        &nbsp;
        <input type="radio" name="step" onChange={handleStepChange} id="boxs32" value="32" checked={step===32} />
        <label htmlFor='boxs32'>32</label>

        <br/>
        <span>View:</span>
        <input type="radio" name="view" onChange={handleViewChange} id="boxglobal" value="global" checked={view=="global"}/>
        <label htmlFor="boxglobal">Global</label>
        <input type="radio" name="view" onChange={handleViewChange} id="boxlocal" value="local" checked={view=="local"}/>
        <label htmlFor="boxlocal">Centering</label>


    </div>)
}